import { notification, Select, Tooltip } from "antd";
import { getRecruiterQuestionSets } from "api/screeningquestions.api";
import QuestionSetTemplateSelector from "components/ScreeningCandidate/ScreeningCandidateForm/QuestionSetTemplateSelector";
import { SvgIcons } from "Icon/SvgIcons";
import React, { useEffect, useState } from "react";

import { Modal, Input, Button, Flex } from "antd";
import { EditOutlined, DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import trashIcon from "../../../images/trash.svg";
import trashIcon1 from "../../../images/trashIcon.svg";
import editOutline from "../../../images/edit-outline.svg";
import { editQuestionSet } from "api/question.api";

const QuestionTemplate = ({ questionId, setQuestionId }: any) => {
    const [questionList, setQuestions] = useState<any>([]);
    const [selectedQuestionSetName, setSelectedQuestionSetName] = useState<string>("");
    const [refresh, setRefresh] = useState<boolean>(false);

    const handleQuestionChange = (id: number, value: any, questionSetName: string) => {
        setQuestionId(id);
        setQuestions(value);
        setSelectedQuestionSetName(questionSetName);
    };

    const [editingIndex, setEditingIndex] = useState<number | null>(null);
    const [editingText, setEditingText] = useState("");
    const [deletingIndex, setDeletingIndex] = useState<number | null>(null);

    // Handlers
    const handleEdit = (index: number) => {
        setEditingIndex(index);
        setEditingText(questionList[index]?.text);
    };

    const handleDelete = (index: number) => {
        setDeletingIndex(index);
    };

    const saveEditedQuestion = async (): Promise<void> => {
        if (editingIndex === null) return;

        try {
            const updatedQuestions = [...questionList];
            const questionSetId = updatedQuestions[editingIndex].question_set;

            updatedQuestions[editingIndex] = {
                ...updatedQuestions[editingIndex],
                text: editingText,
            };

            const payload = {
                name: selectedQuestionSetName,
                questions: updatedQuestions,
            };

            const response = await editQuestionSet(questionSetId, payload);
            console.log("Response Status: ", response);

            // Handle API failure
            if (!response) {
                notification.error({
                    message: "Failed to update",
                    description: response?.message || "Something went wrong while saving the question.",
                });
                return;
            }
            setRefresh(true);
            notification.success({
                message: "Question updated successfully",
            });

            setQuestions(updatedQuestions);
            setEditingIndex(null);
        } catch (error) {
            console.error("Error while updating questions:", error);
            notification.error({
                message: "Update failed",
                description: String(error) || "An unexpected error occurred.",
            });
        }
    };


    const confirmDeleteQuestion = async () => {
        if (deletingIndex !== null) {
            const updated = questionList.filter((_: any, i: number) => i !== deletingIndex);
            try {
                const payload = {
                    name: selectedQuestionSetName,
                    questions: updated
                };
                const response = await editQuestionSet(updated[0].question_set, payload);
                // Handle API failure
                if (!response) {
                    notification.error({
                        message: "Failed to delete",
                        description: response?.message || "Something went wrong while deleting the question.",
                    });
                    return;
                }
                setRefresh(true);
                notification.success({
                    message: "Question deleted successfully",
                });
                setQuestions(updated);
                setDeletingIndex(null);
            } catch (error) {
                console.log("Error while Deleting Question: ", error);
            }
        }
    };

    useEffect(() => {
        console.log("Question List: ", questionList);
    }, [questionList]);

    return (
        <>
            <QuestionSetTemplateSelector onSelect={handleQuestionChange} isLabel={false} isLarge={true} refresh={refresh} setRefresh={setRefresh} />

            {
                questionList.length > 0 && (
                    <>
                        {/* <div className="flex flex-col self-stretch items-start gap-6">
                            <div className="flex flex-col gap-1.5 w-full">
                                <label htmlFor="messageTemplate" className="text-sm flex items-center gap-0.5 font-medium text-gray-700">
                                    Question List <span className="text-primary">*</span>  <Tooltip title="Tooltip text">{SvgIcons.questionSvg}</Tooltip>
                                </label>

                                {
                                    questionList.length > 0 ?
                                        <div className="p-5 bg-[#f5f5f5] mt-1" style={{ backgroundColor: 'rgb(240 249 255 / var(--tw-bg-opacity))', borderRadius: '12px' }}>
                                            <ol style={{ paddingLeft: '20px' }}>
                                                {questionList?.map((question: string, index: number) => (
                                                    <li key={index} className="text-sm text-gray-600 mb-3">{index + 1}. {question}</li>
                                                ))}
                                            </ol>
                                        </div>
                                        :
                                        <></>
                                }
                            </div>
                        </div> */}

                        <div className="mt-4">
                            <div className="flex items-center gap-2 mb-2">
                                <span className="font-semibold">Question List</span>
                                <Tooltip title="These questions are used for prescreening candidates">
                                    <InfoCircleOutlined className="text-gray-400" />
                                </Tooltip>
                            </div>

                            <div className="bg-blue-50 p-4 rounded-md">
                                {questionList.map((question: any, index: number) => (
                                    <div
                                        key={index}
                                        className="flex justify-between items-start py-1 border-b border-transparent hover:border-gray-200"
                                    >
                                        <span className="text-gray-800">
                                            {index + 1}. {question.text}
                                        </span>
                                        <span className="flex gap-2 text-purple-600 text-lg">
                                            <img src={trashIcon} alt="" onClick={() => handleDelete(index)} />
                                            <img src={editOutline} alt="" onClick={() => handleEdit(index)} />
                                        </span>
                                    </div>
                                ))}
                            </div>

                            <Modal
                                title={
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 8 }}>
                                        <div
                                            style={{
                                                backgroundColor: "#E9D7FE",
                                                padding: 10,
                                                borderRadius: "50%",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}
                                        >
                                            <img src={editOutline} alt="" className="text-purple-500" />
                                        </div>
                                        <span style={{ fontSize: 18, fontWeight: 600 }}>Edit Question</span>
                                    </div>
                                }

                                open={editingIndex !== null}
                                onCancel={() => setEditingIndex(null)}
                                footer={[
                                    <Button key="cancel" onClick={() => setEditingIndex(null)}>
                                        Cancel
                                    </Button>,
                                    <Button key="save" style={{ background: "#6941C6", color: "#FFFFFF" }} className="bg-purple-600" onClick={saveEditedQuestion}>
                                        Save
                                    </Button>,
                                ]}
                            >
                                <label className="font-medium">Question *</label>
                                <Input
                                    value={editingText}
                                    onChange={(e) => setEditingText(e.target.value)}
                                    placeholder="Enter question"
                                />
                            </Modal>

                            <Modal
                                title={
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 8 }}>
                                        <div
                                            style={{
                                                backgroundColor: "#FEE4E2",
                                                padding: 10,
                                                borderRadius: "50%",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}
                                        >
                                            <img src={trashIcon1} alt="delete" style={{ width: 20, height: 20 }} />
                                        </div>
                                        <span style={{ fontSize: 18, fontWeight: 600 }}>Delete Question</span>
                                    </div>
                                }

                                open={deletingIndex !== null}
                                onCancel={() => setDeletingIndex(null)}
                                footer={[
                                    <Button key="cancel" onClick={() => setDeletingIndex(null)}>
                                        Cancel
                                    </Button>,
                                    <Button key="confirm" style={{ background: "#6941C6", color: "#FFFFFF" }} onClick={confirmDeleteQuestion}>
                                        Confirm
                                    </Button>,
                                ]}
                            >
                                Are you sure you want to delete this question? This action cannot be undone.
                            </Modal>
                        </div>
                    </>
                )
            }
        </>
    );
};

export default QuestionTemplate;